import { Sparkline } from '@/charts'
import { cn } from '@/lib/utils'
import { KLabel } from './card'

/** Live SCADA reading — value tints warm when over threshold; a pulse shows the feed is live. */
export function ScadaLiveTile({
  label,
  value,
  unit,
  spark,
  threshold,
  over,
  color = 'rgb(var(--stable))',
}: {
  label: string
  value: string | number
  unit: string
  spark?: number[]
  threshold?: number
  over?: boolean
  color?: string
}) {
  const tint = over ? 'rgb(var(--flare))' : color
  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="flex items-center justify-between">
        <KLabel>{label}</KLabel>
        <span
          className={cn('inline-block size-2 rounded-full animate-pulse', over ? 'bg-flare' : 'bg-clear')}
        />
      </div>
      <div
        className="mt-1.5 font-display text-[26px] font-semibold leading-none tabular"
        style={over ? { color: 'rgb(var(--flare))' } : undefined}
      >
        {value}
        <span className="text-[12px] font-medium text-muted-foreground"> {unit}</span>
      </div>
      {spark && spark.length > 1 && (
        <div className="mt-1">
          <Sparkline points={spark} color={tint} height={38} />
        </div>
      )}
      {threshold != null && (
        <div className="mt-1 text-[11px] text-muted-foreground">
          threshold {threshold} {unit}
          {over && <span className="ml-1 font-semibold text-flare">· over</span>}
        </div>
      )}
    </div>
  )
}
